import echartsComponent from './echarts'

const Vchart = {
    install: (Vue) => {
        Vue.component('v-charts', echartsComponent)
    }
}

export default Vchart